export const TOTAL_SDF_HEALTH = 1000;

export const SDF_SENSITIVITY_BOUNDS = {
  low: 1,
  high: 5,
};
